/********************************************************************
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  Adobe permits you to use, modify, and distribute this
 * file in accordance with the terms of the Adobe license agreement
 * accompanying it.
 *******************************************************************/

import { FunctionComponent, VNode } from 'preact';
import { HTMLAttributes } from 'preact/compat';
import { VComponent } from '@adobe-commerce/elsie/lib';
import '@/plp/components/ProductList/ProductList.css';

export interface ProductListProps extends HTMLAttributes<HTMLDivElement> {
  productList?: VNode[];
  header?: VNode;
  footer?: VNode;
  imageWidth?: number;
  imageHeight?: number;
}

export const ProductList: FunctionComponent<ProductListProps> = ({ productList, header, footer, imageWidth, imageHeight }) => {
  return (
    <div className={'product-discovery-product-list'} style={{ '--imageWidth': imageWidth, '--imageHeight': imageHeight }}>
      {header && <div className="product-discovery-product-list__header">{header}</div>}
      <div className="product-discovery-product-list__grid">{productList && <VComponent node={productList} />}</div>
      {footer && <div className="product-discovery-product-list__footer">{footer}</div>}
    </div>
  );
};
